import React from 'react';

import { DynamicProduct } from '../../../DynamicProduct';
import { availableProductFixedIncomeConstant } from '../../../DynamicProduct/components/Product/products/FixedIncome/constants';

export const FixedIncomeContent: React.FC = () => (
  <DynamicProduct infoGetter={() => ({})} product={availableProductFixedIncomeConstant} />
);
